import { FunctionComponent, useEffect, useState } from "react";
import BasicModal, {
  BasicModalProps,
} from "@components/core/modals/BasicModal";
import { useTranslation } from "react-i18next";
import { Input } from "antd";

interface DuplicateModalProps extends BasicModalProps {
  previousName: string;
  onSubmit: (name: string) => void;
}

const DuplicateModal: FunctionComponent<DuplicateModalProps> = ({
  previousName,
  onSubmit,
  ...props
}) => {
  const { t } = useTranslation();

  const [name, setName] = useState<string>(
    t("modal.copy", {
      previousName,
    }),
  );

  useEffect(() => {
    setName(
      t("modal.copy", {
        previousName,
      }),
    );
  }, [previousName]);

  return (
    <BasicModal
      title={t("offices.mailModel.duplicated.modal.title")}
      onOk={() => onSubmit(name)}
      buttonText={t("offices.mailModel.duplicated.modal.validate")}
      {...props}
    >
      <div>
        <span>{t("offices.mailModel.duplicated.modal.description")}</span>
        <Input
          className="mt-8"
          placeholder={t("offices.mailModel.duplicated.modal.placeholder")}
          value={name}
          onChange={(event) => setName(event.target.value)}
        />
      </div>
    </BasicModal>
  );
};

export default DuplicateModal;
